import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import resources, {langs} from './resources';
import {buildYupLocale} from '@/helpers/yup';

const isProduction = process.env.NODE_ENV === 'production';

const detectionOptions = {
	// order and from where user language should be detected
	order: ['querystring', 'localStorage', 'cookie', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
	lookupLocalStorage: '_facturando_lng',
};

i18n.use(LanguageDetector)
	.use(initReactI18next)
	.init(
		{
			resources,
			initImmediate: false,
			detection: detectionOptions,
			lng: 'es', // TODO: cuando el sitio sea multi language, quitar esta linea
			fallbackLng: ['es', 'en'],
			supportedLngs: langs,
			debug: !isProduction,
			interpolation: {
				escapeValue: false,
			},
			react: {
				//wait: true,
				bindI18n: 'languageChanged loaded',
				useSuspense: true,
			},
		},
		buildYupLocale,
	);

export default i18n;
